import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import { DeepLinkHandler } from "./components/DeepLinkHandler";
import { TransitionProvider } from "./contexts/TransitionContext";
import { LandscapeProvider } from "./contexts/LandscapeContext";
import { LandscapeOverlay } from "./components/LandscapeOverlay";

import Index from "./pages/Index";
import { NIP19Page } from "./pages/NIP19Page";
import { CherishedHues } from "./pages/CherishedHues";
import { EditProfile } from "./pages/EditProfile";
import { RemoteLoginSuccess } from "./pages/RemoteLoginSuccess";
import Install from "./pages/Install";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <TransitionProvider>
        <LandscapeProvider>
          <ScrollToTop />
          <DeepLinkHandler />
          <LandscapeOverlay />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/cherished" element={<CherishedHues />} />
            <Route path="/install" element={<Install />} />
            <Route path="/settings/profile" element={<EditProfile />} />
            <Route
              path="/remoteloginsuccess"
              element={<RemoteLoginSuccess />}
            />
            {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
            <Route path="/:nip19" element={<NIP19Page />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </LandscapeProvider>
      </TransitionProvider>
    </BrowserRouter>
  );
}
export default AppRouter;
